import { z } from 'zod';
import { emailValidation } from '../../../validation';

export const ReferrerHealixSchema = z.object({
  email: emailValidation('Your email is required'),
});

export type ReferrerHealix = z.infer<typeof ReferrerHealixSchema>;
